module.exports = __webpack_public_path__ + "models/scene5kids.5124a51.txt";